import { setEnvironment } from '../../config/environment';

export const EnvironmentActionsTypes = {
  ENVIRONMENT_CHANGE: 'ENVIRONMENT_CHANGE',
};

export const changeEnvironment = (environment) => (dispatch) => {
  setEnvironment(environment);

  dispatch({
    type: EnvironmentActionsTypes.ENVIRONMENT_CHANGE,
    payload: environment,
  });
};
